module.exports = __webpack_public_path__ + "static/media/logo-O-White.8c792e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-O-White.png
// module id = 458
// module chunks = 0